import { conflictsStore } from './conflicts-store';

export const selectConflict = conflictsStore.select;
export * from './use-conflicts-state';
